/* Ambrelin – pilules de variantes.
   Si le client choisit une valeur qui n'existe pas avec ses autres choix
   (ex. « Lampadaire » alors que « Ø 80 cm » est coché), on coche la variante
   la plus proche qui garde la valeur choisie, avant que la fiche ne se mette à jour. */
(() => {
  const form = document.querySelector('[data-int-form]');
  const source = document.querySelector('[data-int-variantes]');
  if (!form || !source) return;
  let variantes = [];
  try { variantes = JSON.parse(source.textContent); } catch (e) { return; }
  const groupes = [...form.querySelectorAll('[data-int-option]')];
  if (groupes.length < 2) return;
  const choix = () => groupes.map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
  const existe = (sel) => variantes.some((v) => v.options.every((o, i) => o === sel[i]));
  form.addEventListener('change', (e) => {
    const g = e.target.closest('[data-int-option]');
    if (!g) return;
    const sel = choix();
    if (existe(sel)) return;
    const i = groupes.indexOf(g);
    const score = (v) => v.options.reduce((n, o, k) => n + (o === sel[k] ? 1 : 0), 0) + (v.dispo ? 0.5 : 0);
    const cand = variantes.filter((v) => v.options[i] === sel[i]).sort((a, b) => score(b) - score(a))[0];
    if (!cand) return;
    groupes.forEach((gr, k) => gr.querySelectorAll('input').forEach((inp) => { inp.checked = inp.value === cand.options[k]; }));
  }, true);

  // Hiérarchie : Modèle > Finition > Diamètre. Une pilule d'une rangée
  // inférieure qui n'existe pas avec les choix des rangées au-dessus est
  // désactivée (non cliquable). La première rangée reste toujours cliquable.
  const verrouiller = () => {
    const sel = choix();
    groupes.forEach((g, k) => {
      g.querySelectorAll('.int-pilule').forEach((p) => {
        const inp = p.querySelector('input');
        const ok = k === 0 || variantes.some((v) => v.options[k] === inp.value
          && v.options.slice(0, k).every((o, n) => o === sel[n]));
        inp.disabled = !ok;
        // La rangée Modèle n'est jamais grisée : chaque modèle reste cliquable.
        if (k === 0) p.classList.remove('est-epuise');
        p.classList.toggle('est-bloque', !ok);
      });
    });
  };
  form.addEventListener('change', verrouiller);
  verrouiller();
})();

/* Ajout au panier sans quitter la fiche : le tiroir panier du thème s'ouvre.
   Sans tiroir (ou JavaScript coupé), le formulaire garde son comportement normal. */
(() => {
  const form = document.querySelector('[data-int-form]');
  if (!form || form.dataset.ambAjax) return;
  form.dataset.ambAjax = '1';
  let msg = null;
  form.addEventListener('submit', async (e) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    e.preventDefault();
    const btn = form.querySelector('[data-int-achat]');
    const etaitBloque = btn ? btn.disabled : false;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    if (msg) msg.remove();
    try {
      const fd = new FormData(form);
      const ids = drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
      if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', location.pathname); }
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const d = await r.json();
      if (!r.ok || d.status) throw new Error(d.description || d.message || 'Ajout impossible');
      drawer.classList.remove('is-empty');
      const vide = drawer.querySelector('.drawer__inner-empty');
      if (vide) vide.remove();
      drawer.renderContents(d);
    } catch (err) {
      msg = document.createElement('p');
      msg.className = 'amb-ajout-erreur'; msg.style.cssText = 'margin:10px 0 0;color:#b42828;font-size:.9em';
      msg.setAttribute('role', 'alert');
      msg.textContent = err.message;
      (btn ? btn.parentElement : form).after(msg);
    } finally {
      if (btn) { btn.disabled = etaitBloque; btn.removeAttribute('aria-busy'); }
    }
  });
})();

/* Offre « L'Ensemble » sous le prix (à la place du compte à rebours). */
(() => {
  const promo = document.querySelector('[data-int-promo]');
  if (!promo || document.querySelector('.amb-offre')) return;
  const p = document.createElement('p');
  p.className = 'amb-offre';
  p.innerHTML = "<strong>L'Ensemble</strong><span>-10 % dès 2 luminaires, appliqué automatiquement au panier.</span>";
  promo.after(p);
})();
